export default __webpack_public_path__ + "static/media/wShoes_2_c1.af116cf3.jpeg";